// extracted by mini-css-extract-plugin
module.exports = {"container":"_5DwPenYa","training-title":"_5DnxEVVy","mask":"_5D14SoVZ","loader":"_5D22M9xZ"};